import { ENDPOINTS } from "../config/endpoints";

export const stadiumSchema = {
  steps: [
    {
      title: "Stadium Details",
      fields: [
        {
          name: "name",
          type: "text",
          displayName: "Stadium Name",
          required: true,
        },
        {
          name: "specific_area",
          type: "text",
          displayName: "Specific Area",
        },
        {
          name: "nationality",
          type: "select",
          displayName: "Country",
          fetch: ENDPOINTS.coredata.nationalities,
        },
        {
          name: "state",
          type: "select",
          displayName: "State / UT",
          optionsKey: "INDIAN_STATES",
        },
        {
          name: "city",
          type: "text",
          displayName: "City / District",
        },
        {
          name: "established_year",
          type: "text",
          inputType: "number",
          displayName: "Established Year",
        },
        {
          name: "floodlights",
          type: "text",
          inputType: "number",
          displayName: "Floodlights Count",
        },
        {
          name: "time_zone",
          type: "select",
          displayName: "Time Zone",
          optionsKey: "TIME_ZONES",
        },
        // 2026-06-10 — names of the two physical ends of the ground.
        // Optional but recommended: the BBP "pick bowling end for Over 1"
        // modal only appears when BOTH are filled. Empty for legacy
        // stadiums; SPA falls back to "End A" / "End B" placeholders.
        {
          name: "end_a_name",
          type: "text",
          displayName: "End A name (e.g. Pavilion End)",
        },
        {
          name: "end_b_name",
          type: "text",
          displayName: "End B name (e.g. Members End)",
        },
        {
          name: "home_teams",
          type: "multiselect",
          displayName: "Home Teams",
          fetch: ENDPOINTS.coredata.teams,
        },
      ],
    },
  ],
};
